/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Output of the MandateGetDocument method
 * @export
 * @interface MandateGetDocumentOutput
 */
export interface MandateGetDocumentOutput {
    /**
     * Document in base64
     * @type {string}
     * @memberof MandateGetDocumentOutput
     */
    document?: string;
    /**
     * Document name
     * @type {string}
     * @memberof MandateGetDocumentOutput
     */
    name?: string;
    /**
     * 
     * @type {Error}
     * @memberof MandateGetDocumentOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MandateGetDocumentOutput interface.
 */
export function instanceOfMandateGetDocumentOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MandateGetDocumentOutputFromJSON(json: any): MandateGetDocumentOutput {
    return MandateGetDocumentOutputFromJSONTyped(json, false);
}

export function MandateGetDocumentOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MandateGetDocumentOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'document': !exists(json, 'document') ? undefined : json['document'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MandateGetDocumentOutputToJSON(value?: MandateGetDocumentOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document': value.document,
        'name': value.name,
        'error': value.error,
    };
}

